<pgh-modal-window>
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-title class="title-with-icon">
    <div class="icon-container">
      <mat-icon svgIcon="contract-shield"></mat-icon>
    </div>
    <h4>{{title}}</h4>
  </div>
  <div modal-body class="mt-30 mb-30">
    {{content}}
  </div>
  @if (btnLbl) {
    <div modal-footer>
      <button mat-flat-button color="accent" (click)="onSignupClicked()">{{btnLbl}}</button>
    </div>
  }
</pgh-modal-window>
